import React from 'react';
import { NotesEntityFields } from 'common/graphql/__generated__/NotesEntityFields';
import { NotesSectionProps } from 'common/components/NotesSection';
import { GenericNotesSection } from 'common/components/ActionMenu/Notes';
import { useFormContext } from 'react-hook-form';
import { TripCreateFormValues } from '../../../types';

import {
  NoteTripCreate,
  NoteTripCreateVariables,
} from './__generated__/NoteTripCreate';
import {
  NoteTripItemCreate,
  NoteTripItemCreateVariables,
} from './__generated__/NoteTripItemCreate';

import NOTE_TRIP_CREATE from './NoteTripCreate.graphql';
import NOTE_TRIP_ITEM_CREATE from './NoteTripItemCreate.graphql';

type NotesProps = Pick<NotesSectionProps, 'listRefreshRequest'> & {
  id: string;
  data: NotesEntityFields[];
  loading?: boolean;
  isNoteTripItem?: boolean;
};

export const Notes: React.FC<NotesProps> = ({
  id,
  listRefreshRequest,
  data,
  loading,
  isNoteTripItem,
}) => {
  const {
    formState: { isDirty },
  } = useFormContext<TripCreateFormValues>();

  if (isNoteTripItem) {
    return (
      <GenericNotesSection<
        TripCreateFormValues,
        NoteTripItemCreate,
        NoteTripItemCreateVariables
      >
        entityId={id}
        data={data}
        loading={loading}
        mutationDocument={NOTE_TRIP_ITEM_CREATE}
        listRefreshRequest={listRefreshRequest}
        isViewOnly={false}
      />
    );
  }

  return (
    <GenericNotesSection<
      TripCreateFormValues,
      NoteTripCreate,
      NoteTripCreateVariables
    >
      entityId={id}
      data={data}
      loading={loading}
      mutationDocument={NOTE_TRIP_CREATE}
      listRefreshRequest={listRefreshRequest}
      isViewOnly={false}
    />
  );
};
